<template>
  <div style="background-color:white;">
    <header class="masthead mb-auto">
      <!-- nav fixed top -->
      <nav class="navbar navbar-expand-md navbar fixed-top shadow-sm rsgradient">
        <div class="container" style="display: block;">
          <a class="navbar-brand" href="/">
            <b style="color:#fff;">
              <img src="/img/brand/white.png" class="img-responsive logo" />
            </b>
          </a>
          <!--<nav class="nav nav-masthead justify-content-center">
					<a class="nav-link"  style="color:#fff" href="#">Quienes somos</a>
					<a class="nav-link"  style="color:#fff" href="#">Contacto</a>
					<a href="login" class="btn btn-outline-secondary" style="color:#fff">Ingresar</a>
          </nav>-->
        </div>
      </nav>
    </header>
    <main style="max-width:1072px;margin:auto;margin-top:120px;">
      <div class="row">
        <div class="col-md-12">
          <h1 class="display-4">Recarga ya con tu tarjeta Resimple</h1>
          <p class="titlecustom">
            Ingresa los datos de tu tarjera, selecciona el producto, importe, ingresa tu número y listo
            <b>¡Más simple imposible!</b>
          </p>
        </div>
      </div>
      <hr style="margin-top:0px; margin-bottom:10px;" />
      <div class="row">
        <div class="col-md-12">
          <label class="control-label">Tarjeta</label>
          <input class="form-control" placeholder="XXX XXXX XXX XXXX" v-model="model.Tarjeta" />
        </div>
      </div>
      <div class="row" style="margin-top:20px;">
        <div class="col-md-6">
          <label class="control-label">Compañia</label>
          <!-- <select class="form-control">
            <option>Claro</option>
            <option>Personal</option>
            <option>Movistar</option>
            <option>Tuenti</option>
          </select>-->
          <KitsCombo
            v-model="articuloSelected"
            v-bind:items="articulos"
            propertyName="Name"
            propertyID="EntityID"
          ></KitsCombo>
        </div>
        <div class="col-md-6">
          <label class="control-label">Importe $</label>
          <!-- <input placeholder="$ 00.00" class="form-control" v-model="model.Importe"/> -->
          <vue-numeric
            currency="$"
            v-bind:precision="2"
            decimal-separator="."
            thousand-separator=" "
            v-model="model.Importe"
            class="form-control"
          ></vue-numeric>
        </div>
      </div>

      <div class="row" style="margin-top:20px;">
        <div class="col-md-3">
          <label class="control-label">Prefijo</label>
          <input class="form-control" placeholder="XXX" v-model="model.Aux1" />
        </div>
        <div class="col-md-9">
          <label class="control-label">Número de telefono</label>
          <input placeholder="XXXXXXX" class="form-control" v-model="model.Aux2" />
        </div>
      </div>
      <div class="row" style="margin-top:20px;">
        <div class="col-md-6">
          <input type="checkbox" id="human" name="human" v-model="terms"/>
          <label for="human">
            He leido los
            <a href="#">términos y condiciones</a>
          </label>
        </div>
        <div class="col-md-6">
          <vue-recaptcha
            ref="recaptcha"
            sitekey="6Lc0s3MUAAAAAApx1qe-vgcBkNFaLInEjPK7QPVG"
            :loadRecaptchaScript="true"
            @verify="onCaptchaVerified"
          ></vue-recaptcha>
        </div>
      </div>
      <div class="col-md-12">
        <button
          @click="recharge"
          style="background-color: rgba(255,88,85,1);color:white;"
          type="submit"
          class="btn btn-lg"
        >
          <span class="fa fa-fw fa-plus-square"></span> Recargar
        </button>
      </div>
      <hr style="margin-top:30px; margin-bottom:10px;" />
    </main>
    <footer class="footer mt-auto py-3" style="position: absolute; bottom: 0; width:100%">
      <div class="container">
        <span class="text-muted">
          Resimple
          <small>Dinero en tu celular.</small>
        </span>
        <br />
        <small class="text-muted">Todos los derechos reservados 2019 © Resimple SA</small>
        <small class="text-muted float-right">
          <a href="/legales" class="text-muted">Términos y condiciones</a>
        </small>
      </div>
    </footer>
  </div>
</template>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import CelularFormType from "@/components/FormsType/CelularFormType";
import VueRecaptcha from "vue-recaptcha";
import KitsCombo from "@/components/KitsCombo";
import notificationHelpers from "@/helpers/notificationHelpers";
import loadingHelpers from "@/helpers/loadingHelpers";

export default {
  components: { CelularFormType, VueRecaptcha, KitsCombo },
  name: "login",
  data() {
    return {
      model: {
        Aux1: "",
        Aux2: "",
        Importe: "",
        Tarjeta: ""
      },
      RecaptchaToken: "",
      articulos: [],
      articuloSelected: null,
      estados: { Aprobado: 3, Rechazado: 4, Consulta: 5 },
      terms: false
    };
  },
  methods: {
    onCaptchaVerified: function(recaptchaToken) {
      this.RecaptchaToken = recaptchaToken;
    },
    recharge() {
      let context = this;

      if(this.model.Tarjeta.length!=14){
                notificationHelpers.showError(
                      "Error",
                      "La tarjeta debe tener 14 digitos",
                      context
                    );
                    return;
      }else if(this.model.Importe == "" || this.model.Importe < 0){
                            notificationHelpers.showError(
                      "Error",
                      "Debe ingresar un importe mayor que 0",
                      context
                    );
                    return;
      }else if((this.model.Aux1.length + this.model.Aux2.length)!=10){
                notificationHelpers.showError(
                      "Error",
                      "El numero y prefijo deben sumar 10 digitos",
                      context
                    );
                    return;
      }else if(!context.terms){
        notificationHelpers.showError(
                      "Error",
                      "Debe aceptar los terminos y condiciones",
                      context
                    );
                    return;
      }else if(this.RecaptchaToken==""){
        notificationHelpers.showError(
                      "Error",
                      "Debe ingresar el captcha",
                      context
                    );
                    return;
      }

      var modelReq = {
        Aux1: this.model.Aux1,
        Aux2: this.model.Aux2,
        CardNumber: this.model.Tarjeta.toString().substring(0, 10),
        Pin: this.model.Tarjeta.toString().substring(
          10,
          this.model.Tarjeta.length
        ),
        ArticleID: this.articuloSelected,
        Amount: this.model.Importe,
        Captcha: this.RecaptchaToken
      };
      this.$refs.recaptcha.reset();
      this.RecaptchaToken="";
      axiosHelpers.axiosPost(
        "Recarga/InsertarRecargaTarjeta",
        modelReq,
        this,
        function(data) {
          if (data.ResponseVM.Result > 0) {
            loadingHelpers.showLoading(context);
            setTimeout(() => {
              axiosHelpers.axiosGet(
                "Recarga/ConsultarRecarga",
                { queueID: data.ResponseVM.Result },
                context,
                function(datav) {
                  // context.movimientos = data.ResponseVM;
                  // console.log(data);

                  if (datav.ResponseVM.TransactionStateID == context.estados.Aprobado) {
                    notificationHelpers.showSuccess(
                      "Exito",
                      "La recarga se realizó satisfactoriamente. Número de operación: " +
                        datav.ResponseVM.QueueID +
                        " Número de comprobante: " +
                        datav.ResponseVM.FormatedReceiptID +
                        "",
                      context
                    );

                    context.model = {
                      Aux1: "",
                      Aux2: "",
                      Importe: "",
                      Tarjeta: ""
                    };

                  } else if (datav.ResponseVM.TransactionStateID ==  context.estados.Rechazado) {
                    notificationHelpers.showError(
                      "Error",
                      datav.ResponseVM.ErrorMsg,
                      context
                    );
                  } else {
                    notificationHelpers.showWarning(
                      "Contular",
                      "La operación esta demorada. Le notificaremos el estado final de la misma.",
                      context
                    );
                  }
                }
              );

              data.ResponseVM.Result;
            }, 10000);
          }
        }
      );
    }
  },
  beforeMount() {
    let context = this;
    axiosHelpers.axiosGet(
      "/article/GetForRecargaTarjeta",
      {},
      context,
      function(data) {
        context.articulos = data.ResponseVM;
        context.articuloSelected = data.ResponseVM[0].EntityID;
      }
    );
  }
};
</script>
<style>
body {
  background-color: white;
}
h1,
h2,
h3,
h4,
h5 {
  color: #ff4940;
}
.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}
h1 + p {
  font-size: 1.25em;
  margin-top: -1em;
}
.titlecustom {
  color: #888;
  position: relative;
  margin: 0 0 1.5em 0;
}
strong,
b {
  color: #727a82;
  font-weight: 700;
}
a {
  color: #ff4940;
}

a:hover {
  color: #c93961;
}

.tcpanel {
  padding: 20px;
  background-color: #f9f9f9;
}

.rscolor {
  color: #ff4940;
}

.footer {
  background-color: #f5f5f5;
}

main {
  margin-top: 60px;
}

.logo {
  max-height: 40px;
}

.rsgradient {
  background: rgba(255, 88, 85, 1);
  background: -moz-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(255, 88, 85, 1)),
    color-stop(100%, rgba(201, 57, 98, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 88, 85, 1) 0%,
    rgba(201, 57, 98, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff5855', endColorstr='#c93962', GradientType=0 );
}
.uniform label {
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 3px;
}

.uniform .col-md-12 {
  padding-left: 0;
  padding-right: 0;
}

.validationMessage {
  color: red;
}

.inputFormLabel {
  height: 3.5em;
  line-height: 3.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background: rgba(144, 144, 144, 0.075);
  border-radius: 4px;
  border: none;
  border: solid 1px #dee1e3;
  color: inherit;
  display: block;
  outline: 0;
  padding: 0 1em;
  text-decoration: none;
  width: 100%;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  font-size: 13pt !important;
}

.inputFormLabel:focus {
  border-color: #25a2c3;
  box-shadow: 0 0 0 1px #25a2c3;
}

.select-wrapper select {
  font-size: 13pt !important;
}

.modal-operation-row {
  display: flex;
  align-items: center;
}

.modal-inner-content-container {
  margin-left: 20px;
}

.modalOperation .modal-body button {
  float: left;
  margin-left: 10px;
}

.modal-inner-content-container {
  float: left;
}

.modalOperation button {
  font-family: inherit;
  -webkit-appearance: button;
  text-transform: none;
  overflow: visible;
  margin: 0;
  font: inherit;
  box-sizing: border-box;
  align-items: flex-start;
  font-size: 14px;
  -moz-transition: none;
  -webkit-transition: none;
  -ms-transition: none;
  transition: none;
}

.modal-dialog {
  margin: 150px auto;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.428571429;
}

.btn-circle.btn-lg {
  width: 50px;
  height: 50px;
  padding: 10px 16px;
  border-radius: 25px;
  font-size: 18px;
  line-height: 1.33;
}

.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.modalOperation .modal-body button {
  float: left;
  margin-left: 30px;
}

.control-label {
  color: #a09d9d !important;
  font-weight: 700;
  font-size: 14.4px;
}

h1 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>
